/**
 * Helpers for sidebar drag-and-drop ids.
 *   - Folder / List / Document rows are draggable.
 *   - Space rows are drop targets (drop = move to Space root, clear folderId).
 *   - Folder rows are also drop targets (drop = move into folder, set folderId).
 *     Folders themselves cannot be dropped on a folder (no folder nesting).
 *
 * Drag-data shape (set by useDraggable):
 *   { kind: 'folder'|'list'|'document', id, fromSpaceId, fromFolderId, name }
 *
 * Drop-data shapes (set by useDroppable):
 *   { kind: 'space', spaceId }
 *   { kind: 'folder', spaceId, folderId }
 *   { kind: 'list-reorder', spaceId, listId, position: 'before'|'after' }
 */
export const dragId = (kind, id) => `${kind}:${id}`
export const dropSpaceId = (spaceId) => `drop-space:${spaceId}`
export const dropFolderId = (folderId) => `drop-folder:${folderId}`
export const dropListId = (listId) => `drop-list:${listId}`
